import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
丸背景動き
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const enBg = document.querySelector('.en_bg');
  const showElements = document.querySelectorAll('.show');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // .en_bgが画面内に入った時クラス追加
        showElements.forEach(el => el.classList.add('is-fixed'));
      } else {
        // .en_bgが画面から完全に消えた時削除
        showElements.forEach(el => el.classList.remove('is-fixed'));
      }
    });
  }, {
    threshold: 0
  });

  if (enBg) {
    observer.observe(enBg);
  }
});

/*------------------------------------------------
バナー非表示
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const mvBtns = document.querySelector(".banner");
  const mvBtnNone = document.querySelector(".banner_btn");

  if (mvBtns && mvBtnNone) {
    mvBtnNone.addEventListener("click", () => {
      mvBtns.style.display = "none";
    });
  }
});

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("home")){
  topValidation('zip', 'address01', 'address02');
}

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');
let nav_box = document.querySelector('.hd_nav_box');

if (button && nav_box) {
  button.addEventListener('click', function() {

    if (nav_box.classList.contains('is_open')) {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    } else {
      nav_box.classList.add("is_open");
      button.classList.add("is_close");
    }

  });
}

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

  /*----------------------------------------
  ヘッダー動き
------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const mainSection = document.querySelector('.main');

  if (!header || !mainSection) return;

  let scrollHandler = null;

  const handleScroll = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight;
    const threshold = viewportHeight - 250;

    if (scroll > threshold) {
      header.classList.add('is_fixed');
    } else {
      header.classList.remove('is_fixed');
    }
  };

  const updateScrollEvent = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const mainTop = mainSection.offsetTop;

    // 画面幅が1024以上かつ main の上端が画面の一番上に来たらスクロールイベントを有効化
    if (window.innerWidth >= 1024 && scroll >= mainTop) {
      if (!scrollHandler) {
        scrollHandler = handleScroll;
        window.addEventListener('scroll', scrollHandler);
        handleScroll(); // 初回判定
      }
    } else {
      // 画面幅が1024未満、または main の上端前 → イベント削除
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
        header.classList.remove('is_fixed');
      }
    }
  };

  // 初回実行
  updateScrollEvent();

  // スクロール時に main 上端判定
  window.addEventListener('scroll', updateScrollEvent);

  // リサイズ時にも判定
  window.addEventListener('resize', updateScrollEvent);
});

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      const id = navLink.getAttribute("href");
      if (id === "#" || id === "") return; // ページトップへのリンクなどの空打ち防止

      const target = document.querySelector(id);
      if (!target) return; // ターゲットがない場合は無視

      e.preventDefault();

      // ヘッダーが隠れていても「本来の高さ」を確実に取るための処理
      // もし固定で100pxと決まっているなら 100 と書いてもOK
      const headerHeight = header ? header.getBoundingClientRect().height : 0;

      gsap.to(window, {
        duration: 0.8, // 0.5より少し長めがヌルっとします
        scrollTo: {
          y: target,
          offsetY: headerHeight,
          autoKill: true // ユーザーがスクロールを邪魔したら止める（必須級）
        },
        ease: "power3.out" // ヌルっと感が出るイージング
      });
    });
  });
});
/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      const id = navLink.getAttribute("href");
      const target = document.querySelector(id);
      if (!target || id === "#") return;

      e.preventDefault();

      const offsetValue = window.innerWidth >= 1024 ? 99 : 50;

      gsap.to(window, {
        duration: 0.5,
        ease: "power3.out",
        scrollTo: {
          y: target,
          offsetY: offsetValue,
          autoKill: false
        }
      });
    });
  });
});


/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
top 画像アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

const targets = document.querySelectorAll('.imageanime');
targets.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 70%",
    onEnter: () => target.classList.add('active'),
    once: true
  });
});

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const elements = document.querySelectorAll('.scrollAnim');
elements.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 80%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});

/*----------------------------------------
慣性スクロール
------------------------------------------*/
if (window.innerWidth > 768) { //pcのみ発動
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
}

/*----------------------------------------
カレント（お問い合わせ以外）
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // #contact 以外のセクションを監視対象にする
  const sections = document.querySelectorAll('section[id]:not(#contact)');
  const navLinks = document.querySelectorAll('.hd_nav_link');

  const options = {
    root: null,
    rootMargin: "-50% 0px", // 画面中央付近で切り替え
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 全てのリンクから一旦 is-active クラスを削除
        navLinks.forEach(link => link.classList.remove('is-active'));

        // 現在表示中のセクションIDに紐づくリンクにのみクラスを付与
        const id = entry.target.getAttribute('id');
        const activeLink = document.querySelector(`.hd_nav_link[href="#${id}"]`);

        if (activeLink) {
          activeLink.classList.add('is-active');
        }
      }
    });
  }, options);

  sections.forEach(section => observer.observe(section));

  // お問い合わせに入ったらカレント削除
  const contactSection = document.querySelector('#contact');
  if (contactSection) {
    const contactObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navLinks.forEach(link => link.classList.remove('is-active'));
        }
      });
    }, { rootMargin: "-20% 0px" });
    contactObserver.observe(contactSection);
  }
});

